export enum AuthState {
  authenticating = 'authenticating',
  clientSelect = 'clientSelect',
  confirmSignUp = 'confirmSignUp',
  forgotPassword = 'forgotPassword',
  requireNewPassword = 'requireNewPassword',
  loading = 'loading',
  signIn = 'signIn',
  signedIn = 'signedIn',
  signUp = 'signUp',
  invitation = 'invitation',
}

export enum Channel {
  auth = 'auth',
}

export enum PayloadEvent {
  signIn = 'signIn',
  signUp = 'signUp',
  signOut = 'signOut',
  signIn_failure = 'signIn_failure',
  signUp_failure = 'signUp_failure',
  completeNewPassword_failure = 'completeNewPassword_failure',
  configured = 'configured',
  cognitoHostedUI = 'cognitoHostedUI',
}

export interface ICognitoError {
  code: string;
  name: string;
  message: string;
}

interface IPayloadSignUpData {
  user: object;
  userConfirmed: false;
  userSub: string;
}

export interface IHubCapsule {
  channel: Channel;
  payload: {
    event: PayloadEvent;
    data: ICognitoError & IPayloadSignUpData;
  };
}

export interface ICognitoUser {
  attributes: {
    email: string;
  };
  signInUserSession: {
    idToken: {
      payload: {
        sub: string; // signed in user id
      };
    };
  };
  username: string;
}
